import { css } from '@emotion/react'

import WarningIcon from '../icons/WarningIcon'
import Colors from '../theme/Colors'

export default function ErrorGeneric(props: { children: React.ReactNode; 'data-testid'?: string }) {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        color: ${Colors.Red400};
      `}
      data-testid={props['data-testid']}
    >
      <WarningIcon
        css={css`
          font-size: 18px;
          margin-right: 10px;
        `}
      />

      {props.children}
    </div>
  )
}
